"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MosaicIconFactory = void 0;
class MosaicIconFactory {
    static createIcon(name, className = '', props = {}) {
        const svgNS = 'http://www.w3.org/2000/svg';
        const svg = document.createElementNS(svgNS, 'svg');
        svg.setAttribute('xmlns', svgNS);
        svg.setAttribute('class', `df-icon ${className}`);
        for (const key in props) {
            if (Object.prototype.hasOwnProperty.call(props, key)) {
                svg.setAttribute(key, props[key]);
            }
        }
        const use = document.createElementNS(svgNS, 'use');
        use.setAttribute('href', `/static/icons/${name}.svg#${name}`);
        svg.appendChild(use);
        return svg;
    }
}
exports.MosaicIconFactory = MosaicIconFactory;
